// Hide sub-tasks whose parent is not yet completato.
export function filterVisibleSubtasks(tasks) {
  const byId = new Map(tasks.map((t) => [t.id, t]));
  return tasks.filter((t) => {
    if (!t.is_subtask || !t.parent_task_id) return true;
    const parent = byId.get(t.parent_task_id);
    // Show sub-task once parent is completed
    return !!parent && parent.status === "completato";
  });
}
